import { Component } from '@angular/core';
import { Events, IonicPage, NavController, NavParams,LoadingController } from 'ionic-angular';

/**
 * Generated class for the OthersPaymentsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-others-payments',
  templateUrl: 'others-payments.html',
})
export class OthersPaymentsPage {

  arrOtherPaymentDetails: any;
  

  constructor(public navCtrl: NavController, public navParams: NavParams,public events:Events,public loadingCtrl:LoadingController) {
    this.events.subscribe('EmiPMi:created', (res:any, time) => {
      this.arrOtherPaymentDetails=res.soaSummary.responseParameters;
      //console.log("getting payment other data",this.arrOtherPaymentDetails);
    })
  }
toggleDetails(data) {
    if (data.showDetails) {
      data.showDetails = false;
      data.icon = 'ios-arrow-down';
    } else {
      data.showDetails = true;
      data.icon = 'ios-arrow-up';
    }
  }
  
  ionViewDidLoad() {
     this.events.subscribe('tabsEventDataArrResponceEmiPEmi:created', (res:any, time) => {
      this.arrOtherPaymentDetails=res.soaSummary.responseParameters;
      //console.log("getting payment other data",this.arrOtherPaymentDetails);
    })
      this.ionSelected()
     
  }

  ionSelected(){
    this.events.subscribe('tabsEventDataArrResponceEmiPEmi:created', (res:any, time) => {
      this.arrOtherPaymentDetails=res.soaSummary.responseParameters.filter((res:any)=>{
        return res.amountcr>0 && res.chequestatus=="C"
      });
      //console.log("getting payment other data",this.arrOtherPaymentDetails);
    })
    this.arrOtherPaymentDetails=this.navParams.data.soaSummary.responseParameters.filter((res:any)=>{
      return res.amountcr>0 && res.chequestatus=="C"
    });

     this.arrOtherPaymentDetails.forEach((res:any)=>{
        res.showDetails=false;
        res.icon='ios-arrow-down'
      })
    //console.log("this.emiPemiInfo",this.navParams);
    
     
  }
   

}



// WEBPACK FOOTER //
// ./src/pages/others-payments/others-payments.ts